export function view(value) {
  return value ? 'Content' : 'Empty'
}
